<template>
<div class="container-fluid" v-show="genes.length">
	<table class="table">
		<tbody v-for="gene in genes">
			<tr>
				<td>{{gene}}</td>
			</tr>
		</tbody>
	</table>
</div>
</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import { mapGetters } from 'vuex';
export default {
	name: 'GeneList',
	components:{},
	data () {
		return {
			sort:{by:null,asc:true}
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			datasets:'datasets',
			lists:'lists',
			genes:'genes'
		}),
	},
	methods:{
		showGene(obj){
			let _this = this;
			_this.$set(obj,'$show',!obj.$show)
		},
		sortAction(list,cas){
			let _this = this;
			if (_this.sort.by==cas){
				_this.$set(_this.sort,'asc',!_this.sort.asc)
			}
			else{
				_this.$set(_this.sort,'by',cas)				
				_this.$set(_this.sort,'asc',true)				
			}
			_this.filter(list);
		},
		// filter(l){
		// 	let _this = this;
		// 	_.forEach(_this.lists, function(list){
		// 		list.genes = _.sortBy(list.genes,_this.sort.by);
		// 		if (!_this.sort.asc) list.genes.reverse();
		// 	})
		// }
	},
	mounted() {
		var _this = this;
		// _this.$store.dispatch('getGeneLists').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
